import { Observable, of, tap } from 'rxjs';

/**
 * Abstract class for connectors that require caching.
 * Uses a static Map to share the cache across instances of the connector.
 */
export abstract class ApiCachedConnector {
  private static cache = new Map<string, unknown>();

  /**
   * Returns a cached observable if available, otherwise executes the fetcher and caches the result.
   * @param key Unique key for the cache (e.g. the full URL with params)
   * @param fetcher Function that returns the observable to fetch the data
   */
  protected getCached<T>(key: string, fetcher: () => Observable<T>): Observable<T> {
    const cachedData = ApiCachedConnector.cache.get(key);
    if (cachedData) {
      return of(cachedData as T);
    }

    return fetcher().pipe(
      tap((data) => {
        ApiCachedConnector.cache.set(key, data);
      }),
    );
  }

  /**
   * Clears the cache for all instances.
   */
  public static clearAllCache(): void {
    this.cache.clear();
  }
}
